import { createFileRoute } from "@tanstack/react-router"
import Actions from "@/app/settings/metric/actions/page"

export const Route = createFileRoute("/settings/metric/actions")({
  component: Actions,
})
